import { Measure } from 'services/model/model.service';
import { AnalysisEntry } from 'pages/trading/model';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { BandChartData } from 'components/chart/data/BandChartData';
import { GradientCreator } from 'components/chart/renderer/GradientCreator';
import { IntlShape } from 'react-intl';
import { ChartDataArray } from './ChartDataArray';
import { ChartConfig } from './ChartConfig';
import { tbColors, tbPalette } from 'styles/colors';

export class BandChartConfig extends ChartConfig {
  removeOuterSpacing?: boolean;

  breakdownData?: ChartDataArray[];

  rotateXLabels?: boolean;

  tickPadding = 20;

  breakdownMode?: string;

  additionalAxis?: boolean;

  showTooltips = true;

  gradientCreator: GradientCreator | undefined;

  bandLabel?: string;

  static forMeasure(
    measure: Measure,
    analysisEntry: AnalysisEntry,
    gradientCreator: GradientCreator,
    intl: IntlShape
  ): BandChartConfig {
    const config = new BandChartConfig();
    config.bandLabel = intl.formatMessage({ id: 'chart.band.Label' });

    config.value = {
      code: measure.code,
      label: measure.metric.name,
      unit: measure.metric.unit,
      interpretation: measure.metric.interpretation,
    };
    config.breakdownMode = 'band';
    config.legendConfig = {
      hide: false,
    };
    config.gradientCreator = gradientCreator;

    const lineColor = tbPalette.ui.inverseSecondary;

    const valueArray = new ChartDataArray(
      ChartDataType.breakdown,
      analysisEntry.attributeValue,
      analysisEntry.timeSeries.map(e => new BandChartData(e.date, e.value, e.lowerBound, e.upperBound))
    );
    valueArray.color = lineColor;

    config.data = [
      new ChartDataArray(
        ChartDataType.primary,
        '',
        analysisEntry.timeSeries.map(e => new ChartData(e.date, e.value)),
        undefined
      ),
      valueArray,
    ];

    config.highlightLineColor = tbPalette.surface.grey;
    config.detectionDateMarker = {
      label: intl.formatMessage({ id: 'chart.detectionDate', defaultMessage: 'Detection Date' }),
      color: tbColors.all.sharp[500],
      focusRingColor: tbColors.all.sharp[500],
    };

    return config;
  }
}
